import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import { useMutation } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Review.module.scss';
import dateString from '../../../utils/dates/toString';
import mutation from './queries';
import parseISOLocal from '../../../utils/dates/parseISOLocal';
import Rating from '../../Rating';
import Response from '../Response';
import Stats from '../Stats';
import UpvoteDownvote from '../../UpvoteDownvote';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Review = function Review(_ref) {
  var body = _ref.body,
      createdAt = _ref.createdAt,
      downvotes = _ref.downvotes,
      fitRating = _ref.fitRating,
      heightFeet = _ref.heightFeet,
      heightInches = _ref.heightInches,
      id = _ref.id,
      image = _ref.image,
      name = _ref.name,
      onClickImage = _ref.onClickImage,
      productTitle = _ref.productTitle,
      rating = _ref.rating,
      response = _ref.response,
      sizePurchased = _ref.sizePurchased,
      usualSizePurchased = _ref.usualSizePurchased,
      summary = _ref.summary,
      upvotes = _ref.upvotes;

  var _useMutation = useMutation(mutation),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      res = _useMutation2[0],
      voteOnReview = _useMutation2[1]; // eslint-disable-line


  var executeVote = function executeVote(_ref2) {
    var review = _ref2.id,
        score = _ref2.score;
    voteOnReview({
      review: review,
      score: score
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.stats,
      children: /*#__PURE__*/_jsx(Stats, {
        fitRating: fitRating,
        heightFeet: heightFeet,
        heightInches: heightInches,
        sizePurchased: sizePurchased,
        usualSizePurchased: usualSizePurchased,
        name: name
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.review,
      children: [summary && /*#__PURE__*/_jsx("div", {
        className: css.summary,
        children: summary
      }), /*#__PURE__*/_jsx("div", {
        className: css.rating,
        children: /*#__PURE__*/_jsx(Rating, {
          count: 5,
          size: 16,
          value: rating
        })
      }), /*#__PURE__*/_jsx("div", {
        className: css.date,
        children: dateString(parseISOLocal(createdAt))
      }), /*#__PURE__*/_jsx("div", {
        className: css.body,
        dangerouslySetInnerHTML: {
          __html: body
        }
      }), response && /*#__PURE__*/_jsx(Response, {
        response: response
      }), /*#__PURE__*/_jsx("div", {
        className: css.desktopVotes,
        children: /*#__PURE__*/_jsx(UpvoteDownvote, {
          id: id,
          downvotes: downvotes,
          executeVote: executeVote,
          storageKey: "review_voted_".concat(id),
          upvotes: upvotes
        })
      })]
    }), !image && /*#__PURE__*/_jsx("div", {
      className: cc([css.image, css.hidden]),
      "aria-hidden": "true"
    }), image && /*#__PURE__*/_jsx("button", {
      "aria-label": "Click to enlarge this review",
      className: css.image,
      onClick: onClickImage,
      type: "button",
      children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
        alt: "A customer named ".concat(name, " wearing ").concat(productTitle, " - ").concat(image.alt),
        sizes: [150],
        wrap: false
      }))
    }), /*#__PURE__*/_jsx("div", {
      className: css.mobileVotes,
      children: /*#__PURE__*/_jsx(UpvoteDownvote, {
        id: id,
        downvotes: downvotes,
        executeVote: executeVote,
        storageKey: "review_voted_".concat(id),
        upvotes: upvotes
      })
    })]
  });
};

Review.defaultProps = {
  activities: false,
  fitRating: false,
  heightFeet: false,
  heightInches: false,
  image: false,
  response: false,
  sizePurchased: false,
  summary: false,
  usualSizePurchased: false,
  weight: false
};
Review.propTypes = {
  activities: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  body: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  downvotes: PropTypes.number.isRequired,
  fitRating: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  heightFeet: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  heightInches: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  id: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  name: PropTypes.string.isRequired,
  onClickImage: PropTypes.func,
  productTitle: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  response: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  sizePurchased: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  summary: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  upvotes: PropTypes.number.isRequired,
  usualSizePurchased: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  weight: PropTypes.oneOfType([PropTypes.bool, PropTypes.number])
};
export default Review;